import React from 'react';
import Homepage_Data from '../../../utils/HomepageData';

export default function AboutSection() {
  return (
    <div className="lg:mx-auto w-full">
      {/* Heading */}
      <h2 className='font-bold text-[24px] mt-[40px] mx-[20px] mb-[10px] lg:text-[40px] lg:text-center  lg:mb-[20px]'>
        About
      </h2>

      {/* Content Container */}
      <div className='bg-[#7B3BCC] py-[25px] sm:w-full px-[20px] lg:py-[50px] lg:px-[120px]'>
        <div className='bg-[#FFFFFF] rounded-[34px] px-[20px] lg:px-[60px] lg:py-[40px]'>
          {/* Title */}
          <h2 className='text-center text-[22px] font-bold text-[#2C2C2C] pt-[15px] lg:text-[40px] lg:pt-[0]'>
            {Homepage_Data.aboutData.heading}
          </h2>

          {/* Paragraphs */}
          <p className='text-center text-[16px] text-[#888888] mt-[25px] lg:text-[20px] lg:mt-[30px] lg:max-w-[800px] lg:mx-auto font-[500]'>
          {Homepage_Data.aboutData.para1}
          </p>
          <p className='text-center text-[16px] text-[#888888] mt-[25px] lg:text-[20px] lg:mt-[30px] lg:max-w-[800px] lg:mx-auto font-[500]'>
          {Homepage_Data.aboutData.para2}
          </p>
          <p className='text-center text-[16px] text-[#888888] mt-[25px] pb-[15px] lg:text-[20px] lg:mt-[30px] lg:pb-[0] lg:max-w-[800px] lg:mx-auto font-[500]'>
          {Homepage_Data.aboutData.para3}

          </p>
        </div>
      </div>
    </div>
  );
}